import { useQuery } from '@tanstack/react-query';
import { api } from '../../api/client';

interface Summary {
  total_paid_cents: number;
  total_paid_brl: number;
  total_paid_count: number;
  by_status: Record<string, { count: number; amount_cents: number }>;
}

const STATUS_LABEL: Record<string, string> = {
  draft: 'Rascunho',
  awaiting_payment: 'Aguardando pagamento',
  awaiting_manual_confirmation: 'Aguardando conf. manual',
  paid: 'Pago',
  cancelled: 'Cancelado',
};

export default function AdminSummary() {
  const { data } = useQuery({
    queryKey: ['admin-summary'],
    queryFn: async () => (await api.get<Summary>('/admin/financial-summary')).data,
    refetchInterval: 30_000,
  });

  if (!data) return <div>Carregando…</div>;

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">Resumo financeiro</h2>

      <div className="grid sm:grid-cols-3 gap-3">
        <div className="card">
          <div className="text-xs text-slate-500">Total recebido</div>
          <div className="text-2xl font-bold text-brand-600">
            R$ {data.total_paid_brl.toFixed(2)}
          </div>
          <div className="text-xs">{data.total_paid_count} bolões pagos</div>
        </div>
        {Object.entries(data.by_status)
          .filter(([k]) => k !== 'paid')
          .map(([k, v]) => (
            <div key={k} className="card">
              <div className="text-xs text-slate-500">{STATUS_LABEL[k] || k}</div>
              <div className="text-lg font-semibold">{v.count}</div>
              <div className="text-xs">R$ {(v.amount_cents / 100).toFixed(2)} potencial</div>
            </div>
          ))}
      </div>
    </div>
  );
}
